/**
 * /w/:wsId/n and /w/:wsId/n/:pageId
 *
 * `NotebookShell` carries the workspace-scoped realtime subscription and
 * the page tree; the route param `$pageId` decides whether the main view
 * is the empty state or a real page. The sidebar in `workspace.tsx`
 * already has a Pages group; this route is the destination.
 */

import { useParams } from '@tanstack/react-router'
import { NotebookShell } from '@/components/notebook/NotebookShell'

export function NotebookPage() {
  const params = useParams({ strict: false }) as { wsId: string }
  return <NotebookShell wsId={params.wsId} />
}
